import { View } from "../../../core/view/index";
import BBPlugin from "../../../core/bbclient/plugin";
import BBrowser from "../../../core/bbclient/browser";
import { LazyTemplate, Template } from "../../../core/template/index";
import MessageModal from "../../../core/modals/message/index";
import ConfirmModal from "../../../core/modals/confirm/index";
import { ModalResultType } from "../../../core/modal/index";
import MenuActionItem from "./item/index";
import AppIcons from "../../icons";
import { AutoSyncResult } from "../../../core/synchronizer";

export default class MainMenuView extends View
{
    public template = Template.lazy('/app/views/mainmenu/index.html');

    private items: MenuActionItem[];

    public beforeRender(): PromiseLike<any>
    {
        this.app.synchronizer.on('synchronized', () => {
            if (this.app.synchronizer.lastAutoSyncResult === AutoSyncResult.CHANGED) {
                location.reload();
            }
        });
        this.app.header.text = this.pgettext('Title', 'Main menu');
        this.app.header.iconClass = 'im im-list';

        this.items = [];

        if (!this.app.user) {
            return;
        }

        // Decontamination items
        if (this.app.user.hasPerm('decontamination'))
        {
            this.items.push(new MenuActionItem({
                iconClass: AppIcons.QRCode,
                title: this.app.pgettext('decontamination', 'Decontamination'),
                hash: '#/order/scan'
            }));
        }

        // Package tracking items
        if (this.app.user.hasPerm('package_tracking')) {
            this.items.push(new MenuActionItem({
                iconClass: AppIcons.PackageTracking_Receive,
                title: this.app.pgettext('package_tracking', 'Receive packages'),
                hash: '#/package_tracking/receive/'
            }));

            this.items.push(new MenuActionItem({
                iconClass: AppIcons.PackageTracking_Collect,
                title: this.app.pgettext('package_tracking', 'Collect for delivery'),
                hash: '#/package_tracking/delivery/collect'
            }));

            this.items.push(new MenuActionItem({
                iconClass: AppIcons.PackageTracking_List,
                title: this.app.pgettext('package_tracking', 'Deliveries list'),
                hash: '#/package_tracking/delivery/list'
            }));
        }

        let promises: PromiseLike<any>[] = [];

        for (let item of this.items)
        {
            promises.push(this.app.renderPartialView(item));
        }

        return Promise.all(promises);
    }

    public afterRender(): PromiseLike<void>
    {
        for(let item of this.items)
        {
            this.appendChild(item);
        }
        return super.afterRender();
    }
}
